import { LoadingButton } from "@mui/lab";
import { ButtonProps, styled } from "@mui/material";

const LoadingCustomButton = styled(LoadingButton)<ButtonProps>(() => ({
   color: "var(--buttonText)",
   backgroundColor: "var(--button)",
   "&:hover": {
      backgroundColor: "var(--buttonHover)",
   },
}));

export default LoadingCustomButton;
